<input type="email" bind:value maxlength={100} />

<script lang="ts">
  export let value: string; /* in/out */
</script>

<style>
</style>
